/* import __COLOCATED_TEMPLATE__ from './click-point.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();